import React, { useState } from 'react';
import { db } from '../firebase';
import { collection, addDoc, Timestamp } from 'firebase/firestore';
import './FormStylePatient.css';
import { useTenant } from '../context/TenantContext';
import { toast } from 'react-toastify';

const AddPatientForm = () => {
  const [formData, setFormData] = useState({
    firstname: '',
    lastname: '',
    age: '',
    gender: '',
    email: '',
    phone: ''
  });
  const { tenantId } = useTenant();

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, 'patients'), {
        ...formData,
        name: `${formData.firstname} ${formData.lastname}`,
        createdAt: Timestamp.now(),
        tenantId
      });
      toast.success('Patient added successfully');
      setFormData({
        firstname: '',
        lastname: '',
        age: '',
        gender: '',
        email: '',
        phone: ''
      });
    } catch (error) {
      console.error('Error adding patient:', error);
      toast.error('Failed to add patient');
    }
  };

  return (
    <div className="form-container">
      <h2>Add Patient</h2>
      <form onSubmit={handleSubmit}>
        <div className="name-fields">
          <div className='firstname-field'>
            <label>First name:</label>
            <input type="text" name="firstname" value={formData.firstname} onChange={handleChange} required />
          </div>
          <div className='lastname-field'>
            <label>Last name:</label>
            <input type="text" name="lastname" value={formData.lastname} onChange={handleChange} />
          </div>
        </div>
        
        <label>Age:</label>
        <input type="number" name="age" value={formData.age} onChange={handleChange} placeholder='Age*' required />

        <label>Gender:</label>
        <select name="gender" value={formData.gender} onChange={handleChange} required>
          <option value="">Select Gender</option>
          <option value="Male">Male</option>
          <option value="Female">Female</option>
          <option value="Other">Other</option>
        </select>

        <label>Email:</label>
        <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder='email (optional)' />

        <label>Phone:</label>
        <input type="tel" name="phone" value={formData.phone} onChange={handleChange} placeholder='Phone number*' required />

        <button type="submit">Add Patient</button>
      </form>
    </div>
  );
};

export default AddPatientForm;
